import { useState, useEffect } from 'react';
import { getProgress } from '../utils/api';

export const useProgress = () => {
  const [progress, setProgress] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchProgress = async () => {
    try {
      const res = await getProgress();
      setProgress(res.data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchProgress(); }, []);

  const getDayProgress = (dayNum) => progress.find(p => p.day_num === dayNum) || {};

  const isDayUnlocked = (dayNum) => {
    if (dayNum === 1) return true;
    const prev = getDayProgress(dayNum - 1);
    return prev.day_complete === true;
  };

  const isDayComplete = (dayNum) => getDayProgress(dayNum).day_complete || false;
  const completedDays = progress.filter(p => p.day_complete).length;

  return { progress, loading, getDayProgress, isDayUnlocked, isDayComplete, completedDays, refetch: fetchProgress };
};
